/**
 * Create element
 *
 * @param {string} type
 * @returns HTMLElement
 */
export const createElement = (type) => document.createElement(type);

/**
 * Query class | id | ...
 *
 * @param {string} selector
 * @returns HTMLElement
 */
export const select = (selector) => document.querySelector(selector);

/**
 * QuerySelectorAll class | id | ...
 *
 * @param {string} selector
 * @returns HTMLElement
 */
export const selectAll = (selector) => document.querySelectorAll(selector);

/**
 * Get body element
 */
export const body = select("body");

/**
 * Convert first letter to uppercase
 *
 * @param {stirng} string
 * @returns HTMLElement
 */
export const capitalize = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

/**
 * Clear stirng for i18n replace all spaces
 * as well as other characters not allowed
 *
 * @param {string} string
 * @returns
 */
export const clearei18n = (string) => {
  return string
    .trim()
    .replace(/[^a-zA-Z ]/g, "")
    .replace(/ /g, "-")
    .toLowerCase();
};

/**
 * Convert JSON to Array
 *
 * @param {object} json - json object
 * @returns Array
 */
export const convertJSONToArray = (json) => {
  // Object.values(players);
  const array = [];
  for (let key in json) {
    array.push(json[key]);
  }
  return array;
};

/**
 * Check is object empty
 *
 * @param {object} obj
 * @returns
 */
export const isObjectEmpty = (obj) => Object.keys(obj).length === 0;

/**
 * Set property to root html element
 *
 * @param {HTMLElement} root
 * @param {string} name
 * @param {string} height
 * @returns
 */
export const setPropertyHeight = (root, name, height) => {
  return root.style.setProperty(name, height);
};

/**
 * Get item from localStorage
 *
 * @param {string} nameItem
 * @returns
 */
export const getItemLocalStorage = (nameItem) =>
  JSON.parse(localStorage.getItem(nameItem));

/**
 * Set item to localStorage
 *
 * @param {string} nameItem
 * @param {string} value
 * @returns
 */
export const setItemLocalStorage = (nameItem, value) =>
  localStorage.setItem(nameItem, JSON.stringify(value));

/**
 * Remove item from localStorage
 *
 * @param {string} nameItem
 * @returns
 */
export const removeLocalStorage = (nameItem) =>
  localStorage.removeItem(nameItem);

/**
 * Count row in tbody
 *
 * @param {HTMLElement} table
 * @returns number
 */
export const countRowInTable = (table) =>
  table.querySelectorAll("tbody > tr").length;

/**
 * Count object inside array
 */
export const countObjectIsideArray = (storage) => {
  return storage.reduce(
    (counter, { status }) => (status === "0" ? (counter += 1) : counter),
    0
  );
};

/**
 * Detect if device is mobile
 */
export const hasTouchScreen = () => {
  let hasTouchScreen = false;
  if ("maxTouchPoints" in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ("msMaxTouchPoints" in navigator) {
    hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
    const mQ = window.matchMedia && matchMedia("(pointer:coarse)");
    if (mQ && mQ.media === "(pointer:coarse)") {
      hasTouchScreen = !!mQ.matches;
    } else if ("orientation" in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      const UA = navigator.userAgent;
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }
  return hasTouchScreen;
};

/**
 * Check if header exist
 */
export const checkIfHeaderExist = () => {
  const checkHeader = select("#header");
  return checkHeader ? "76px" : "0px";
};

/**
 * Check if custom info exitst (red backgroun)
 */
export const checkIfCustomInfoExist = () => {
  const custonInfoMessage = select(".custon-info-message");
  return custonInfoMessage ? "26px" : "0px";
};

/**
 * Check ap ID, comparing the name from
 * localstorage with what comes from the backend
 */
export const checkApID = () => {
  const getAppID = getItemLocalStorage("HQappID");
  if (!getAppID) {
    setItemLocalStorage("HQappID", HQ.Properties.appId);
  } else if (HQ.Properties.appId !== getAppID) {
    // kep offline map (HQofflineMap)
    const offlineMap = getItemLocalStorage("HQofflineMap");
    localStorage.clear();
    setItemLocalStorage("HQappID", HQ.Properties.appId);
    // set item to local storage (HQofflineMap)
    setItemLocalStorage("HQofflineMap", offlineMap);

    // cleare indexDB when change appID
    try {
      LeafletOffline?.truncate();
    } catch (error) {}
  }
};

/**
 * Compare to date and return true if timeNow is bigger than time
 *
 * @param {string} time
 * @returns boolean
 */
export const compareTwoTimes = (time) => {
  let curTime = new Date();
  curTime = parseInt(
    curTime.getHours() + "" + ("0" + curTime.getMinutes()).slice(-2)
  );

  return curTime > time.replace(":", "") ? true : false;
};

/**
 * Get bounds from to points
 */
export const getBounds = () => {
  const southWest = new L.LatLng(...HQ.Properties.maxBounds.southWest);
  const northEast = new L.LatLng(...HQ.Properties.maxBounds.northEast);
  return new L.LatLngBounds(southWest, northEast);
};

/**
 * Return length of object
 * @returns {number}
 */
export const objectLength = (object) => Object.keys(object).length;

/**
 * Array equals
 *
 * @param {array} a
 * @param {array} b
 * @returns
 */
export const arrayEquals = (a, b) => {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index])
  );
};

/**
 * Check if var is undefined
 *
 * @param {string} varName
 * @returns
 */
export const checkIfVarExist = (varName) => {
  return typeof varName === "undefined" ? false : true;
};

/**
 * Create svg icon with color, class name and name icon
 *
 * @param {object} class name, color icon, name icon
 */
export const svgIcon = ({ className, color, name }) => {
  const iconClassName = className ? `class="${className}"` : "";
  const iconColor = color ? `fill="${color}"` : "";
  return `<svg ${iconClassName}${iconColor}><use href="#${name}"></use></svg>`;
};

/**
 * Create span row width class *
 *
 * @param {string} className
 * @param {string} numberScores
 * @returns
 */
export const scoreNumberHtmlElement = (className, numberScores) => {
  return `<span class="text-${className}">${numberScores}</span>`;
};

/**
 * Create span row width class *
 *
 * @param {string} className
 * @param {string} numberScores
 * @returns
 */
export const scoreNumberLeaderboard = (className, typeIcon, numberScores) => {
  return `<div class="icon-type-${typeIcon} leaderboard-color icon-${className}">${numberScores}</div>`;
};

/**
 * Get path url for vapor
 *
 * @returns String
 */
export const getPathForVapor = (logo) => {
  let imageStarWith = logo.startsWith("https://") ? true : false;
  return imageStarWith ? logo : document.body.dataset.path + logo;
};

/**
 * Check if iphone | ipad | ipod
 *
 * @returns boolean
 */
export const ios = () =>
  /iP(hone|od|ad)/.test(navigator.userAgent) && !window.MSStream;

/**
 * Fix issue width calculate height popup center
 */
export const updatePopupHeightCalculate = () => {
  const leafletPopupPane = select(".leaflet-popup-pane");

  const groupPopup = selectAll(".group-popup");
  if (groupPopup) return;

  leafletPopupPane?.addEventListener(
    "load",
    (e) => {
      let tagName = e.target.tagName;
      let popup = map._popup;

      if (tagName === "IMG" && popup && !popup._updated) {
        popup._updated = true; // Set flag to prevent looping.
        popup.update();
        setTimeout(() => {
          let px = map.project(popup._latlng);
          px.y -= popup._container.clientHeight / 2.2;
          map.panTo(map.unproject(px));
          popup._updated = false;
        }, 200);
      }
    },
    true
  );
};

/**
 * Set cookie
 *
 * @param {String} name
 * @param {String} value
 * @param {Number} days
 */
export const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    let date = new Date();
    // date.setTime(date.getTime() + 30 * 1000); // 30 sec expires
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

/**
 * Get cookie
 *
 * @param {String} name
 * @returns null
 */
export const getCookie = (name) => {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * Erase cookie
 *
 * @param {String} name
 */
export const eraseCookie = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

/**
 * Set new localstorage
 */
export const removeIdFromLocalStorage = (id, storageName) => {
  const getLocalStorage = getItemLocalStorage("HQfavoritePlayers");
  const newLocalStorage = getLocalStorage.filter((x) => x !== id);
  setItemLocalStorage(storageName, newLocalStorage);
};

/**
 * Copy element to memory
 *
 * @param {string} data
 */
export const ClipboardWriteText = (data) => {
  const input = document.createElement("input");
  input.classList.add("temp-input");
  input.setAttribute("style", "display: none;");

  document.body.appendChild(input);
  input.value = data;

  if (navigator.clipboard) {
    const buffer = navigator.clipboard.writeText(input.value);

    buffer.then(
      () => {
        // console.log(input.value);
        input.value = "";
      },
      () => {
        /* Rejected - clipboard failed */
        // console.log(";aaaaaaaaaa");
      }
    );
  } else {
    console.log("Browser Not compatible");
  }
};

/**
 * Get color from courses array depense on curse_id
 *
 * @param {number} courseID
 */
export const GetColorFromCourse = (coursID) => {
  if (!HQ.Properties.isMultiCourse) return;

  const arrayObj = convertJSONToArray(HQ.Properties.courses);
  return arrayObj.find((element) => element.id === coursID).color;
};

/**
 * Run Ads events
 *
 * @param {Boolean} type
 */
export const CreateAdsSlotInLeaderBoard = (type) => {
  const timeout =
    type === "autocomplete" ||
    type === "autocomplete-update" ||
    type === "autocomplete-clear"
      ? 500
      : 0;

  setTimeout(() => {
    function handleIntersection(entries) {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          try {
            var tude = window.tude || { cmd: [] };

            // const midcontent = entry.target.dataset.md;
            // console.log(midcontent);

            const baseSlot = entry.target.dataset.baseSlot;
            const slotId = entry.target.id;
            // console.log("slotId exist", slotId);
            tude.cmd.push(function () {
              window.tude.refreshAdsViaDivMappings([
                {
                  divId: slotId,
                  baseDivId: `pb-slot-leader-${baseSlot}`,
                  //   pos: midcontent,
                },
              ]);
            });
          } catch (error) {}

          observer.unobserve(entry.target);
        }
      });
    }

    const adsRow = selectAll(".ads-row");
    // console.log("adsRow", adsRow.length);

    const observer = new IntersectionObserver(handleIntersection);
    adsRow.forEach((num) => observer.observe(num));
  }, timeout);
};

/**
 * Check if number is integer if not add
 * 1/2 [&#189] to number and return string
 *
 * @param {Number} points
 * @returns String
 */
export const checkIsNumberIsInteger = (points) => {
  let score;
  if (points) {
    // https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/569
    const floorPoints = Math.floor(points);
    const floorPointsCheck = floorPoints > 0 ? `${floorPoints} &#189` : "&#189";
    score = Number.isInteger(points) ? points : floorPointsCheck;
  } else {
    score = 0;
  }
  return score;
};

/**
 * Center the popup with the marker in the middle of the page
 *
 * @param {object} layer
 */
export const centerPlaceInView = (layer, zoom_levels) => {
  const latlng = layer.getLatLng();

  // popup height / 2
  const getPopupHeight = layer._popup._container.clientHeight;
  const offsetHeight = getPopupHeight > 200 ? getPopupHeight / 3 : 0;

  // convert latlng to points on map
  const x = map.latLngToContainerPoint(latlng).x;
  const y = map.latLngToContainerPoint(latlng).y - offsetHeight;

  // convert points to latlng
  const newLatLng = map.containerPointToLatLng([x, y]);

  // get zoom from object zoom_levels first element
  // if zoom_elements dosn't exist get map zoom
  map.flyTo(newLatLng, zoom_levels?.shift() ?? map.getZoom());
};

/**
 * Convert special char
 *
 * @param {string} string
 * @returns string
 */
export const ConvertToAscii = (string) => {
  // prettier-ignore
  const unicodeToAsciiMap = {
    Ⱥ: "A", Æ: "AE", Ꜻ: "AV", Ɓ: "B", Ƀ: "B", Ƃ: "B", Ƈ: "C", Ȼ: "C", Ɗ: "D", ǲ: "D", ǅ: "D", Đ: "D", Ƌ: "D", Ǆ: "DZ", Ɇ: "E", Ꝫ: "ET", Ƒ: "F", Ɠ: "G", Ǥ: "G", Ⱨ: "H", Ħ: "H", Ɨ: "I", Ꝺ: "D", Ꝼ: "F", Ᵹ: "G", Ꞃ: "R", Ꞅ: "S", Ꞇ: "T", Ꝭ: "IS", Ɉ: "J", Ⱪ: "K", Ꝃ: "K", Ƙ: "K", Ꝁ: "K", Ꝅ: "K", Ƚ: "L", Ⱡ: "L", Ꝉ: "L", Ŀ: "L", Ɫ: "L", ǈ: "L", Ł: "L", Ɱ: "M", Ɲ: "N", Ƞ: "N", ǋ: "N", Ꝋ: "O", Ꝍ: "O", Ɵ: "O", Ø: "O", Ƣ: "OI", Ɛ: "E", Ɔ: "O", Ȣ: "OU", Ꝓ: "P", Ƥ: "P", Ꝕ: "P", Ᵽ: "P", Ꝑ: "P", Ꝙ: "Q", Ꝗ: "Q", Ɍ: "R", Ɽ: "R", Ꜿ: "C", Ǝ: "E", Ⱦ: "T", Ƭ: "T", Ʈ: "T", Ŧ: "T", Ɐ: "A", Ꞁ: "L", Ɯ: "M", Ʌ: "V", Ꝟ: "V", Ʋ: "V", Ⱳ: "W", Ƴ: "Y", Ỿ: "Y", Ɏ: "Y", Ⱬ: "Z", Ȥ: "Z", Ƶ: "Z", Œ: "OE", ᴀ: "A", ᴁ: "AE", ʙ: "B", ᴃ: "B", ᴄ: "C", ᴅ: "D", ᴇ: "E", ꜰ: "F", ɢ: "G", ʛ: "G", ʜ: "H", ɪ: "I", ʁ: "R", ᴊ: "J", ᴋ: "K", ʟ: "L", ᴌ: "L", ᴍ: "M", ɴ: "N", ᴏ: "O", ɶ: "OE", ᴐ: "O", ᴕ: "OU", ᴘ: "P", ʀ: "R", ᴎ: "N", ᴙ: "R", ꜱ: "S", ᴛ: "T", ⱻ: "E", ᴚ: "R", ᴜ: "U", ᴠ: "V", ᴡ: "W", ʏ: "Y", ᴢ: "Z", ᶏ: "a", ẚ: "a", ⱥ: "a", æ: "ae", ꜻ: "av", ɓ: "b", ᵬ: "b", ᶀ: "b", ƀ: "b", ƃ: "b", ɵ: "o", ɕ: "c", ƈ: "c", ȼ: "c", ȡ: "d", ɗ: "d", ᶑ: "d", ᵭ: "d", ᶁ: "d", đ: "d", ɖ: "d", ƌ: "d", ı: "i", ȷ: "j", ɟ: "j", ʄ: "j", ǆ: "dz", ⱸ: "e", ᶒ: "e", ɇ: "e", ꝫ: "et", ƒ: "f", ᵮ: "f", ᶂ: "f", ɠ: "g", ᶃ: "g", ǥ: "g", ⱨ: "h", ɦ: "h", ħ: "h", ƕ: "hv", ᶖ: "i", ɨ: "i", ꝺ: "d", ꝼ: "f", ᵹ: "g", ꞃ: "r", ꞅ: "s", ꞇ: "t", ꝭ: "is", ʝ: "j", ɉ: "j", ⱪ: "k", ꝃ: "k", ƙ: "k", ᶄ: "k", ꝁ: "k", ꝅ: "k", ƚ: "l", ɬ: "l", ȴ: "l", ⱡ: "l", ꝉ: "l", ŀ: "l", ɫ: "l", ᶅ: "l", ɭ: "l", ł: "l", ſ: "s", ẜ: "s", ẝ: "s", ɱ: "m", ᵯ: "m", ᶆ: "m", ȵ: "n", ɲ: "n", ƞ: "n", ᵰ: "n", ᶇ: "n", ɳ: "n", ꝋ: "o", ꝍ: "o", ⱺ: "o", ø: "o", ƣ: "oi", ɛ: "e", ᶓ: "e", ɔ: "o", ᶗ: "o", ȣ: "ou", ꝓ: "p", ƥ: "p", ᵱ: "p", ᶈ: "p", ꝕ: "p", ᵽ: "p", ꝑ: "p", ꝙ: "q", ʠ: "q", ɋ: "q", ꝗ: "q", ɾ: "r", ᵳ: "r", ɼ: "r", ᵲ: "r", ᶉ: "r", ɍ: "r", ɽ: "r", ↄ: "c", ꜿ: "c", ɘ: "e", ɿ: "r", ʂ: "s", ᵴ: "s", ᶊ: "s", ȿ: "s", ɡ: "g", ᴑ: "o", ᴓ: "o", ᴝ: "u", ȶ: "t", ⱦ: "t", ƭ: "t", ᵵ: "t", ƫ: "t", ʈ: "t", ŧ: "t", ᵺ: "th", ɐ: "a", ᴂ: "ae", ǝ: "e", ᵷ: "g", ɥ: "h", ʮ: "h", ʯ: "h", ᴉ: "i", ʞ: "k", ꞁ: "l", ɯ: "m", ɰ: "m", ᴔ: "oe", ɹ: "r", ɻ: "r", ɺ: "r", ⱹ: "r", ʇ: "t", ʌ: "v", ʍ: "w", ʎ: "y", ᶙ: "u", ᵫ: "ue", ꝸ: "um", ⱴ: "v", ꝟ: "v", ʋ: "v", ᶌ: "v", ⱱ: "v", ⱳ: "w", ᶍ: "x", ƴ: "y", ỿ: "y", ɏ: "y", ʑ: "z", ⱬ: "z", ȥ: "z", ᵶ: "z", ᶎ: "z", ʐ: "z", ƶ: "z", ɀ: "z", œ: "oe", ₓ: "x"
  };
  const stringWithoutAccents = string
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
  return stringWithoutAccents.replace(
    /[^\u0000-\u007E]/g,
    (character) => unicodeToAsciiMap[character] || ""
  );
};

/**
 * Create distane to place if you have latitude and longitude
 *
 * @param {string} place
 */
export const showDistanceToPlace = (place, hole, typeDistance) => {
  const lat = document.documentElement.style.getPropertyValue("--lat");
  const lng = document.documentElement.style.getPropertyValue("--lng");

  const [latPlace, lngPlace] = place.split(",").map(Number);

  if (!latPlace) return;

  let distanceNumber;

  // if hole exist
  if (hole) {
    const { latlng_green, latlng_tee } = hole || {};

    // if latlng_green and latlng_tee exist
    const [latGreen, lngGreen] = latlng_green.split(",").map(Number);
    const [latTee, lngTee] = latlng_tee.split(",").map(Number);

    // get distance from green
    const distanceGreen = getDistance(
      [latGreen, lngGreen],
      [lat, lng],
      typeDistance
    );

    // get distance from tee
    const distanceTee = getDistance([latTee, lngTee], [lat, lng], typeDistance);

    // set distance to place [tee / green]
    distanceNumber = `${distanceTee} / ${distanceGreen}`;
  } else {
    // get distance from place
    distanceNumber = getDistance(
      [latPlace, lngPlace],
      [lat, lng],
      typeDistance
    );
  }

  return distanceNumber;
};

/**
 * Get distance between two points
 *
 * @param {array} fromLatLng
 * @param {array} toLatLng
 * @param {string} typeDistance
 */
export const getDistance = (fromLatLng, toLatLng, typeDistance) => {
  const from = L.marker(fromLatLng).getLatLng();
  const to = L.marker(toLatLng).getLatLng();

  const yard = 1.0936;

  const distance =
    typeDistance === "yards" ? from.distanceTo(to) * yard : from.distanceTo(to);

  let distanceNumber = distance.toFixed(0);

  if (distanceNumber <= 10) {
    distanceNumber = 10;
  } else {
    distanceNumber = Math.round(distanceNumber / 10) * 10;
  }
  return distanceNumber;
};

/**
 * Remove base from indexedDB
 *
 * @param {string} base
 */
export const removeBaseFromIndexedDB = (base) => {
  window.indexedDB.databases().then((databaseList) => {
    databaseList.forEach(() => {
      console.log("databaseList", databaseList, base);
      window.indexedDB.deleteDatabase(base);
    });
  });
};

/**
 * Sort object by keys
 *
 * @param {object} object
 * @param {boolean} param1
 * @returns object
 */
export const sortObjectByKeys = (object, { desc = false } = {}) =>
  Object.fromEntries(
    Object.entries(object).sort(([k1], [k2]) => ((k1 < k2) ^ desc ? -1 : 1))
  );

/**
 * Get location search
 */
export const locationSearch = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams;
};

/**
 * Create new position for place
 *
 * @param {number} offset
 * @param {array} latlng
 * @returns array
 */
export const calculateNewPosition = (latlng, offset) => {
  const sidebarHeight = select(".sidebar")?.clientHeight;
  const getMapHeight = map.getSize().y / 2 - sidebarHeight - offset;
  const latLng = map.latLngToContainerPoint(latlng);
  // const newLatLng = map.containerPointToLatLng([latLng.x, latLng.y + offset]);
  const newLatLng = map.containerPointToLatLng([
    latLng.x,
    latLng.y - getMapHeight,
  ]);

  return newLatLng;
};

/**
 * Get player headshot
 *
 * @param {object} playerId
 */
export const getHeadshot = (playerId) => {
  const player = HQ.Properties.players.find(
    (player) => player.PlayerId === playerId
  );

  if (!player) return;

  const image = player.image;

  return image;
};

/**
 *Find sponsor logo by name
 *
 * @param {string} name
 */
export const findSponsorLogoByName = (partnerName) => {
  const partners = window["partners"]
    .map(({ name, logo_positive }) => {
      if (name !== partnerName) return;
      return `<img src="${logo_positive}" class="img-fluid parnter-logo ms-2" loading="lazy">`;
    })
    .join("");

  return partners ? partners : "";
};

/**
 * Max safe integer
 * 53-bit is safe integer
 */
export const maxInt = Number.MAX_SAFE_INTEGER;
